// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../common/JQueryView';

export default class ShowView extends JQueryView {
  purpose_id = '';

  constructor(purpose_id: string) {
    super('.simple_form');
    this.purpose_id = purpose_id;
    this.render();
  }

  @on({ event: 'click', selector: '.capital_policy' })
  onClickCapitalPolicy() {
    this.purpose_id = 'capital_policy';
    this.render();
  }

  @on({ event: 'click', selector: '.stockholder' })
  onClickStockholder() {
    this.purpose_id = 'stockholder';
    this.render();
  }

  @on({ event: 'click', selector: '.stockholder_meeting' })
  onClickStockholderMeeting() {
    this.purpose_id = 'stockholder_meeting';
    this.render();
  }

  @on({ event: 'click', selector: '.other' })
  onClickOther() {
    this.purpose_id = 'other';
    this.render();
  }

  @on({ event: 'click', selector: '.submit-button' })
  onClickSubmitBtn() {
    if (!this.purpose_id) {
      $('.error-msg').css('display', 'flex');
    }
  }

  render() {
    $('#company_purpose_id_of_personalization').val(this.purpose_id);
    if (this.purpose_id) {
      $('.submit-button').removeAttr('onclick', 'return false');
      $('.purpose-type').removeClass('active');
      $(`.${this.purpose_id}`).addClass('active');
    } else {
      $('.submit-button').attr('onclick', 'return false');
      $('.purpose-type').removeClass('active');
    }
  }
}
